import { Typography } from "@mui/material"

import BannerLayout from "../BannerLayout"

interface PublicBannerProps {
  text: string
}

const PublicBanner = ({ text }: PublicBannerProps) => {
  return (
    <BannerLayout
      bgcolor="primary.main"
      color="white"
      alignItems={{ xs: "flex-start", sm: "center" }}
    >
      <Typography variant="inherit">{text}</Typography>
    </BannerLayout>
  )
}

export default PublicBanner
